module.exports = __webpack_public_path__ + "static/media/hearts-jack.1c42caaf.png";